import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import Api from '../../services/api';
import withRouter from "../../services/withRouter";
import Modal from 'react-bootstrap/Modal';

class Helplines extends React.Component {
    

   
    componentDidMount = async () => {
        window.scrollTo(0, 0);
        this.getHelplines();
    };



    getHelplines = async()=>{
        var response = await Api.GetRequest({}, 'helplines');
        if(response.status == 200){
            this.setState({'helplines' : response.helplines});
        }
    }



    constructor(props) {
        super(props);
        this.state = {
            'helplines' : [],
            'external_link' : "",
            "show_alert" : false
        };
    }


    showExternalLink = async()=>{
        this.setState({'show_alert' : false})
        window.open(this.state.external_link, "_blank")
    }
    

    render(){

        return(
            <>

                <Modal show={this.state.show_alert} centered >
                    <Modal.Header closeButton>
                    </Modal.Header>

                    <Modal.Body>
                        <p class='text-center'>You are about to proceed to an external website. Click YES to proceed.</p>
                    </Modal.Body>

                    <Modal.Footer>
                        <button className="btn btn_theme btn_md mt-3 py-1" onClick={()=>{this.setState({'show_alert' : false})}}>Close</button>

                        <button className="btn btn_theme btn_md mt-3 py-1" onClick={()=>{this.showExternalLink()}}>Ok</button>
                    </Modal.Footer>
                </Modal>

                
                <div class="m-0 shadow"  style={{'width' : '100vw!important', 'maxWidth' : '100vw!important'}}>
                    <div class="row mx-0">
                        <div class="col-lg-12 p-0">
                            <div class="commn_banner_page" style={{'position' : 'relative'}} >
                                <img src="/assets/img/header_banner.png" class="page-banner-image" style={{'width' : '100vw'}}/>
                                <h2 className="mb-0 page-label" style={{'position' : 'absolute',  textAlign : 'left', 'top' : '40%', width:'50%', lineHeight:'normal', 'left' : '10%', 'color' : '#000000', "textTransform" : "uppercase"}}>Helplines</h2>
                            </div>
                        </div>
                    </div>
                </div>

                <section id="trending_causes_main" class="px-2" style={{'marginTop':'50px', 'marginBottom' : '50px'}}>
                    <div class="container-fluid px-0">
                        <div class="row mx-0" id="counter">
                            {this.state.helplines.map((help)=>{
                                return(
                                    <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                                        <div class="case_boxed_wrapper bordered" style={{'border' : '1px solid #000000'}}>
                                            <div class="case_boxed_img">
                                                <a href="javascript:;">
                                                    <img src={process.env.REACT_APP_SERVER + help.image} alt="img"/>
                                                </a>
                                            </div>
                                            <div class="causes_boxed_text">
                                                <h5 style={{'height' : '43px'}}>
                                                    <a href="javascript:;" style={{'color' : '#000000'}}>{help.title}</a>
                                                </h5>
                                                <a href="javascript:;" onClick={()=>{this.setState({'external_link' : help.link, 'show_alert' : true})}}><button className="btn btn_theme btn_md mt-3 py-1">Click Here..</button></a>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </section>
            </>
        )
    }
}


export default withRouter(Helplines)